import { Container } from "@material-ui/core";
import React, { Fragment } from "react";
import contactbanner from "assets/images/contact_banner.jpg";
import { getToken } from "middleware/storage";
import ContentWrapper from "components/public-dashboard/components/contentWrapper";
import PageBanner from "components/public-dashboard/components/page_banner";
import ContactContent from "./content";
import ContactHeader from "./header";
import useDocumentTitle from "../../../../hooks/useDocumentTitle";

export default function OptOut() {
    useDocumentTitle(
    "Opt-Out or Reset Cookie Settings | YOOZ",
    "Adjust or opt out of your previously saved YOOZ website visitor cookie settings here."
  );

  const token = getToken();
  if (token) {
    return (
      <Container maxWidth="lg">
        <ContactHeader />
        <ContactContent />{" "}
      </Container>
    );
  }

  return (
    <Fragment>
      <ContentWrapper>
        <ContactHeader />
        <ContactContent />
      </ContentWrapper>
    </Fragment>
  );
}
